// Helpers to safely handle Base64 decoding for API keys stored in localStorage.

const looksBase64 = (s: string) => /^[A-Za-z0-9+/=]+$/.test(s) && s.length % 4 === 0;

export const decodeIfBase64 = (raw: string) => {
    const trimmed = (raw || '').trim();
    if (!trimmed) return '';
    if (!looksBase64(trimmed)) return raw;
    try {
        const decoded = atob(trimmed);
        // If decoded contains non-printable characters, treat as raw (not actually base64 for our intent)
        if (/[^\x20-\x7E]/.test(decoded)) return raw;
        return decoded;
    } catch {
        return raw;
    }
};
